import {Culture, cultureService} from "@/CultureService";

export class LogoService {
    getLogoName(useColor : boolean) {
        switch (cultureService.currentCulture) {
            case Culture.Estonian:
                return useColor
                    ? "Transpordiamet_vapp_varviline_est.svg"
                    : "Transpordiamet_vapp_valge_est.svg"
            case Culture.English:
                return useColor
                    ? "Transpordiamet_vapp_varviline_eng.svg"
                    : "Transpordiamet_vapp_valge_eng.svg"
            default:
                throw Error(`Unknown culture: [${cultureService.currentCulture}]`);
        }
    }

    getMobileLogoName(useColor : boolean) {
        return useColor
            ? "Transpordiamet_vapp_varviline_ikoon.svg"
            : "Transpordiamet_vapp_valge_ikoon.svg"
    }
}

export const logoService = new LogoService();
